import {
  TOGGLE_PERMISSION,
  TOGGLE_CATEGORY_PERMISSIONS,
  SET_CATEGORY_PERMISSIONS,
  SET_CATEGORIES,
  SET_PERMISSIONS,
  SET_ROLES,
  SET_ROOT_CATEGORY,
  SET_SELECTED_PERMISSIONS,
  SET_USERS,
  SHOW_DELETE_USER_MODAL,
} from './constants'

const getPermissionsFromCategory = function (category) {
  let permissions = []
  for (let subCategory of category.sub_categories) {
    permissions.push.apply(permissions, getPermissionsFromCategory(subCategory))
  }
  permissions.push.apply(permissions, category.permissions)
  return permissions
}

const setPermissionsFromCategory = function (category, permissions, setValue) {
  for (let subCategory of category.sub_categories) {
    permissions = setPermissionsFromCategory(subCategory, permissions, setValue)
  }
  if (!permissions[category.id]) {
    permissions[category.id] = []
  }
  if (setValue) {
    permissions[category.id] = category.permissions.map(p => p.id)
  } else {
    permissions[category.id] = []
  }
  return permissions
}

const setSelectedCategories = function (rootCategory, permissions) {
  let permissionKeys = Object.keys(permissions)
  let listOfPerms = permissionKeys.reduce((prev, key) => {
    permissions[key].forEach(el => prev.push(el))
    return prev
  }, [])
  let permissionSet = new Set(listOfPerms)
  let categoriesFilled = {}
  transversePermissions(rootCategory, permissionSet, categoriesFilled)
  return categoriesFilled
}

const transversePermissions = function (rootCategory, permissionSet, categoriesFilled) {
  let filledChildren = true
  let booleanList = []
  for (let subCat of rootCategory.sub_categories) {
    booleanList.push(transversePermissions(subCat, permissionSet, categoriesFilled))
  }
  booleanList.forEach(b => {
    filledChildren = filledChildren && b
  })
  let hasPerms = true
  for (let perm of rootCategory.permissions) {
    hasPerms = hasPerms && permissionSet.has(perm.id)
  }
  let filled = filledChildren && hasPerms
  categoriesFilled[rootCategory.id] = filled
  return filled
}

const setPermissionsForCategories = function (permissions, rootCategory, categoryPermissions) {
  for (let subCat of rootCategory.sub_categories) {
    setPermissionsForCategories(permissions, subCat, categoryPermissions)
  }
  categoryPermissions[rootCategory.id] = rootCategory.permissions
    .filter(el => permissions.includes(el.id))
    .map(el => el.id)
  return categoryPermissions
}

const mutations = {
  [TOGGLE_PERMISSION](state, { permissionId, categoryId }) {
    if (!state.selectedPermissions[categoryId]) {
      state.selectedPermissions[categoryId] = []
    }
    let perms = state.selectedPermissions[categoryId]
    let filtered = perms.filter(p => p === permissionId)
    if (filtered.length > 0) {
      state.selectedPermissions[categoryId] = perms.filter(p => p !== permissionId)
    } else {
      perms.push(permissionId)
    }
    state.selectedCategories = setSelectedCategories(state.rootCategory, state.selectedPermissions)
  },
  [TOGGLE_CATEGORY_PERMISSIONS](state, { category, setValue }) {
    setPermissionsFromCategory(category, state.selectedPermissions, setValue)
    state.selectedPermissions = { ...state.selectedPermissions }
    state.selectedCategories = setSelectedCategories(state.rootCategory, state.selectedPermissions)
  },
  [SET_CATEGORY_PERMISSIONS](state, { categoryId, permissions }) {
    state.selectedPermissions[categoryId] = permissions
    state.selectedPermissions = { ...state.selectedPermissions }
    state.selectedCategories = setSelectedCategories(state.rootCategory, state.selectedPermissions)
  },
  [SET_SELECTED_PERMISSIONS](state, permissions) {
    state.selectedPermissions = setPermissionsForCategories(permissions, state.rootCategory, {})
    state.selectedCategories = setSelectedCategories(state.rootCategory, state.selectedPermissions)
  },
  [SET_CATEGORIES](state, categories) {
    state.categories = categories
  },
  [SET_PERMISSIONS](state, permissions) {
    state.appPermissions = permissions.reduce((permission, p) => {
      permission[p.name] = p.id
      return permission
    }, {})
  },
  [SET_ROLES](state, roles) {
    state.roles = roles
  },
  [SET_ROOT_CATEGORY](state, category) {
    state.rootCategory = category
  },
  [SET_USERS](state, users) {
    state.users = users
  },
  [SHOW_DELETE_USER_MODAL](state) {
    state.showDeleteUserModal = state.showDeleteUserModal ? state.showDeleteUserModal + 1 : 1
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/appLogic/permissions/store/mutations.js